import * as yup from 'yup';

const passwordField = yup
  .string()
  .required('Please provide a password')
  .matches(
    /^(?=.*[A-Z])(?=.*\d).{8,}$/,
    'Password must be at least eight characters long and include at least one uppercase letter and one number'
  );

const passwordConfirmationField = yup
  .string()
  .required('Please provide a password confirmation')
  .matches(
    /^(?=.*[A-Z])(?=.*\d).{8,}$/,
    'Password must be at least eight characters long and include at least one uppercase letter and one number'
  )
  .oneOf([yup.ref('password'), null], 'Passwords must match');

export const schema = yup.object().shape({
  firstName: yup.string().required('Please provide a first name'),
  lastName: yup.string().required('Please provide a last name'),
  password: passwordField,
  passwordConfirmation: passwordConfirmationField,
  mobilePhoneNumber: yup
    .string()
    .test(
      'valid',
      'Please provide a valid phone number',
      (mobile_phone_number) => !!(!mobile_phone_number || mobile_phone_number?.length === 10)
    ),
});

export const ssoSchema = yup.object().shape({
  firstName: yup.string().required('Please provide a first name'),
  lastName: yup.string().required('Please provide a last name'),
  mobilePhoneNumber: yup
    .string()
    .test(
      'valid',
      'Please provide a valid phone number',
      (mobile_phone_number) => !!(!mobile_phone_number || mobile_phone_number?.length === 10)
    ),
});

export const onsiteStaffSchema = (enableDailyQueueAssignedLocations: boolean) =>
  yup.object().shape({
    firstName: yup.string().required('Please provide a first name'),
    lastName: yup.string().required('Please provide a last name'),
    password: passwordField,
    passwordConfirmation: passwordConfirmationField,
    jobTitle: yup.string().required('Please provide a job title'),
    location: enableDailyQueueAssignedLocations
      ? yup.object().nullable() // not required
      : yup.object().required('Location is required'), // required
  });

export const ssoOnsiteStaffSchema = (enableDailyQueueAssignedLocations: boolean) =>
  yup.object().shape({
    firstName: yup.string().required('Please provide a first name'),
    lastName: yup.string().required('Please provide a last name'),
    jobTitle: yup.string().required('Please provide a job title'),
    location: enableDailyQueueAssignedLocations
      ? yup.object().nullable() // not required
      : yup.object().required('Location is required'), // required
  });
